import React from 'react';

// Mapeos rápidos para emojis comunes con secuencias especiales
const SPECIAL_EMOJI_MAP: Record<string, string> = {
  '🥇': '1f947',
  '🥈': '1f948',
  '🥉': '1f949',
  '🟢': '1f7e2',
  '🟡': '1f7e1',
  '🔴': '1f534',
  '🍔': '1f354',
  '📅': '1f4c5',
  '🏢': '1f3e2',
  '🔗': '1f517',
  '🖼': '1f5bc',
  '🖼️': '1f5bc',
  '⚙': '2699',
  '⚙️': '2699',
  '⭐': '2b50',
  '🔥': '1f525',
  '✨': '2728',
  '🎉': '1f389',
  '🚀': '1f680',
  '💯': '1f4af',
  '❤️': '2764',
  '💙': '1f499',
  '💜': '1f49c',
  '🖤': '1f5a4',
  '👍': '1f44d',
  '👎': '1f44e',
  '👏': '1f44f',
  '🙌': '1f64c',
  '👐': '1f450',
  '🤝': '1f91d',
  '🙏': '1f64f',
  '✌': '270c',
  '🤞': '1f91e',
  '🤙': '1f919',
  '💪': '1f4aa',
  '📁': '1f4c1',
  '📎': '1f4ce',
  '📌': '1f4cc',
  '📝': '1f4dd',
  '📊': '1f4ca',
  '📈': '1f4c8',
  '💡': '1f4a1',
  '🎯': '1f3af',
  '🏆': '1f3c6',
  '⏰': '23f0',
  '💬': '1f4ac',
  '📞': '1f4de',
  '🎥': '1f3a5',
  '🎨': '1f3a8',
  '🔑': '1f511',
  '🔒': '1f512',
  '😀': '1f600',
  '😃': '1f603',
  '😄': '1f604',
  '😁': '1f601',
  '😆': '1f606',
  '😅': '1f605',
  '🤣': '1f923',
  '😂': '1f602',
  '🙂': '1f642',
  '😊': '1f60a',
  '😇': '1f607',
  '🥰': '1f970',
  '😍': '1f60d',
  '🤩': '1f929',
  '😘': '1f618',
  '😗': '1f617',
  '😋': '1f60b',
  '😜': '1f61c',
  '😎': '1f60e',
  '🤓': '1f913',
  '🥳': '1f973',
  '🤔': '1f914',
  '🤫': '1f92b',
  '🤗': '1f917'
};

export const emojiToUnified = (emoji: string): string => {
  if (!emoji) return '';
  if (SPECIAL_EMOJI_MAP[emoji]) return SPECIAL_EMOJI_MAP[emoji];

  const codePoints: string[] = [];
  for (let i = 0; i < emoji.length; i++) {
    const code = emoji.codePointAt(i);
    if (code !== undefined) {
      if (code !== 0xfe0f) {
        codePoints.push(code.toString(16).toLowerCase());
      }
      if (code > 0xffff) {
        i++;
      }
    }
  }
  return codePoints.join('-');
};

export const getAppleEmojiUrl = (emojiOrUnified: string): string => {
  if (!emojiOrUnified) return '';
  const unified = SPECIAL_EMOJI_MAP[emojiOrUnified] ||
    (emojiOrUnified.includes('-') || /^[0-9a-f]{4,6}$/i.test(emojiOrUnified)
      ? emojiOrUnified.toLowerCase()
      : emojiToUnified(emojiOrUnified));
  return `https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/${unified}.png`;
};

interface AppleEmojiProps {
  symbol?: string;
  unified?: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
}

export const AppleEmoji: React.FC<AppleEmojiProps> = ({
  symbol,
  unified,
  size = 18,
  className,
  style,
  alt
}) => {
  const code = unified || (symbol ? emojiToUnified(symbol) : '');
  const url = `https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/${code}.png`;

  return (
    <img
      src={url}
      alt={alt || symbol || 'emoji'}
      loading="lazy"
      onError={(e) => {
        const target = e.currentTarget as HTMLImageElement;
        target.style.display = 'none';
        if (target.parentElement && symbol) {
          const span = document.createElement('span');
          span.innerText = symbol;
          span.style.fontSize = `${size}px`;
          span.style.lineHeight = '1';
          target.parentElement.appendChild(span);
        }
      }}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        display: 'inline-block',
        verticalAlign: '-0.15em',
        objectFit: 'contain',
        flexShrink: 0,
        ...style
      }}
      className={className}
    />
  );
};

export default AppleEmoji;
